<template>
    <div class="scc-registration-check-text">
        <div class="scc-registration-check-text-container">
            <template v-if="loading || !order">
                <h1>{{ options.pending.title }}</h1>
                <p>{{ options.pending.text }}</p>
            </template>
            <template v-else-if="order.error">
                <h1>{{ options.failed.title }}</h1>
                <p>{{ options.failed.text }}</p>
            </template>
            <template v-else-if="order">
                <template v-if="order.status === 'cancelled'">
                    <h1>{{ options.failed.title }}</h1>
                    <p>{{ options.failed.text }}</p>
                </template>

                <template v-else-if="order.status === 'paid'">
                    <h1>{{ options.success.title }}</h1>
                    <p>{{ options.success.text }}</p>
                    <p>{{ options.success.content }}</p>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegistrationCheckText',
    props: {
        pending: {
            title: {
                type: String,
                default() {
                    return 'Jouw aanmelding wordt bevestigd...';
                },
            },
            text: {
                type: String,
                default() {
                    return 'Nog eventjes geduld. Jouw aanmelding wordt op dit moment verwerkt.';
                },
            },
            content: {
                type: String,
                default() {
                    return '';
                },
            },
        },
        failed: {
            title: {
                type: String,
                default() {
                    return 'Aanmelding mislukt!';
                },
            },
            text: {
                type: String,
                default() {
                    return 'Jouw aanmelding is niet gelukt of de betaling is niet voltooid. Probeer het opnieuw.';
                },
            },
            content: {
                type: String,
                default() {
                    return '';
                },
            },
        },
        success: {
            title: {
                type: String,
                default() {
                    return 'Bedankt voor je aanmelding!';
                },
            },
            text: {
                type: String,
                default() {
                    return 'Door mee te doen maak je kans op mooie prijzen.';
                },
            },
            content: {
                type: String,
                default() {
                    return '';
                },
            },
        },
        order: {
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            loading: false,
            error: false,
        };
    },
};
</script>

<style lang="scss">
.scc-registration-check-text {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1280px;
    margin: 60px auto;

    .scc-registration-check-text-container {
        max-width: 600px;
        padding: 0 20px;
        margin: 0 auto;

        h1 {
            margin-bottom: 10px;
        }
    }
}
</style>
